import React, { createContext, useContext, useEffect, useState } from "react";
import constants from "../constants";

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState(constants.DEFAULT_THEME);

    useEffect(() => {
        const body = document.querySelector("body");

        // clear themerelated classes
        [...body.classList].forEach(cls => {
            if (cls.startsWith("theme-")) {
                document.body.classList.remove(cls);
            }
        });

        // then add current theme class
        body.classList.add(`theme-${theme}`);
    }, [theme]);

    return (
        <ThemeContext.Provider value={{ theme, setTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    return useContext(ThemeContext);
}